import React, {useState} from "react";
import {Row} from "antd";
import {useFetch} from "hooks/useFetch";
import Filters from "./filters/Filters";
import ResponsiveDataTable from "./responsiveDataTable/ResponsiveDataTable";
import ActionButtons from "./actionButtons/ActionButtons";
import {useObserver} from "mobx-react-lite";
import {useStore} from "hooks/useStore";

const EquipmentRequests = () => {
    const stores = useStore();
    const [recall, setRecall] = React.useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [filters, setFilters] = useState({
        status: "all",
        zoneManagementId: undefined,
        zoneId: undefined,
        startDate: undefined,
        endDate: undefined,
        searchText: undefined
    });

    const [loading, requests] = useFetch({
        fetchFn: stores.equipmentRequestStore.listRequests.bind(null, {
            limit: 10,
            page: currentPage,
            status: filters?.status !== "all" ? filters?.status : undefined,
            zoneManagementId: filters?.zoneManagementId,
            zoneId: filters?.zoneId,
            startDate: filters?.startDate,
            endDate: filters?.endDate,
            searchText: filters?.searchText
        }),
        dependencies: [recall, filters, currentPage]
    });

    return useObserver(() => (
        <div>
            <Row gutter={[8, 8]}>
                <Filters
                    setCurrentPage={setCurrentPage}
                    setFilters={setFilters}
                    filters={filters}
                />
            </Row>
            <Row justify="end" style={{marginTop: 16, marginBottom: 16}}>
                <ActionButtons recall={() => setRecall(!recall)} />
            </Row>
            <Row>
                <ResponsiveDataTable
                    loading={loading}
                    data={requests?.rows || []}
                    dataCount={requests?.total || 0}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    recall={() => setRecall(!recall)}
                />
            </Row>
        </div>
    ));
};

export default EquipmentRequests;
